module.exports = __webpack_public_path__ + "img/cmw_cmtokenomics.af7f493.png";